import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseArrow = ({ className }: IProps) => (
    <svg
        className={className}
        fill="black"
        height="22"
        viewBox="0 0 24 22"
        width="24"
    >
        <path d="M13.025 0L10.178 2.828L16.354 9.004H0V12.996H16.354L10.178 19.172L13.025 22L24 11L13.025 0Z" />
    </svg>
);

export const Arrow = styled(BaseArrow)``;
